class OfferEdit {
    constructor(config) {
        this.config = Object.assign({
            scope: '.offer-edit',
            removeImageButton: '.remove-image'
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$scope.on('change', '#image', this.toggleImg.bind(this));
        this.$scope.on('click', this.config.removeImageButton, this.removeImg.bind(this));
    }

    toggleImg(e) {
        let imageWrapper = this.$scope.find('.preview-image');
        let src = URL.createObjectURL(e.currentTarget.files[0]);

        $('#image_changed').val(1);

        imageWrapper.find('img').remove();
        imageWrapper.prepend('<img style="width: 300px; max-width: 90%" class="mb-3" src="' + src + '"/>')
    }

    removeImg(e) {
        e.preventDefault();

        $('#image_changed').val(1);

        $(document).find('.preview-image img').remove();
        this.$scope.find('#image').val('').removeAttr('val');
    }
}

export default new OfferEdit();
